import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { ITooltip } from '../../index'
import EditIcon from '../../Icons/js/icons/EditIcon'

export default function EditModeButton ({ onEditMode, setOnEditMode, className, disabled }) {
  return (
    <Box
      className={className}
      sx={{
        alignItems: 'center',
        display: 'flex',
        flex: '0 0 36px',
        height: 36,
        justifyContent: 'center',
        width: 36
      }}
    >
      <ITooltip placement='top' content='Edit'>
        <IconButton
          disabled={disabled}
          onClick={() => setOnEditMode(!onEditMode)}
          type='button'
          sx={(theme) => ({
            borderRadius: '50%',
            boxSizing: 'border-box',
            height: 36,
            padding: '6px',
            width: 36,
            '& svg *': {
              fill: onEditMode ? theme.palette.primary.accent : undefined
            }
          })}
        >
          <EditIcon />
        </IconButton>
      </ITooltip>
    </Box>
  )
}
